import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-saleOrder';
	$(base, context).each(function(){
		var component = $(this);
		
		var readMore = component.find('.i-readMore');

		readMore.on('click', function(e) {
			e.preventDefault();

			var personalContent = $('.i-saleOrder-personal');

			personalContent.toggleClass('m-active').slideToggle();

			if (personalContent.hasClass('m-active')) {
				$(this).text('Скрыть');
			} else {
				$(this).text('Раскрыть');
			}
		});
	});
});
